import React, { useEffect } from 'react';
import { MdClose } from "react-icons/md";

function PopupModal(props) {
    const { isOpen, setIsOpen, popupFor, name, children, size } = props;

    // Disable body scroll when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        // Cleanup on unmount
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    return (
        <div>
            {isOpen && (
                <div
                    id="popup-modal"
                    className="fixed inset-0 z-[3000] flex items-center justify-center overflow-y-auto overflow-x-hidden bg-black bg-opacity-50"
                >
                    <div className={`relative p-4 w-full max-w-4xl max-h-full`}>
                        <div className={`relative bg-white rounded-lg p-4 shadow border-2 border-secondary-light dark:bg-[#FBFBFB] ${size === "small" ? "w-[80%] mx-auto" : "w-full"}`}>
                            
                            {/* Modal Header */}
                            <div className="flex border-b-2 border-gray-500 items-center justify-between">
                                <p className={`mb-0 text-[35px] font-bold ${popupFor === 'SUSPENSION!!' ? 'text-red-600 uppercase' : ''}`}>
                                    {popupFor}
                                </p>

                                {popupFor !== "Login" && (
                                    <MdClose
                                        size={30}
                                        onClick={() => setIsOpen(false)}
                                        className="cursor-pointer duration-300 hover:text-white hover:bg-gray-500 rounded"
                                    />
                                )}
                            </div>

                            <div>{children}</div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default PopupModal;
